import React, { useEffect, useState } from "react";
import { profile_banner } from "../_components/Imagepath";
// import FeatherIcon from "feather-icons-react";
import { Link } from 'react-router-dom';

import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
// import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
// import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";

const CustomerProfile = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
 // const [profileImageUrl, setProfileImageUrl] = useState("");

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    axios
      .post(
        "/customerportal/user-profile",
        {},
        {
          headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.user);
        } else {
         window.location.href = "/customerportal/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });


  }, []);

  return (
    <>
      <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row justify-content-lg-center">
              <div className="col-lg-12">
                <div className="page-header">
                  <div className="content-page-header">
                    <h5>Profile</h5>
                  </div>
                </div>
                <div className="profile-cover">
                  <div className="profile-cover-wrap">
                    <img
                      className="profile-cover-img"
                      src={profile_banner}
                      alt="Profile Cover"
                    />
                  </div>
                </div>
                <div className="text-center mb-5">
                 
                  
                </div>
              </div>
                <div className="col-lg-12">
                       <div className="card">
                          <div className="card-header">
                              <h5 className="card-title d-flex justify-content-between">
                                  <span>User Profile</span> 
                                  <Link className="btn btn-sm btn-white" to="/customerportal/update-profile">Edit</Link>
                              </h5>
                          </div>
                          <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>First Name</th>
                                <td>{data.user_first_name}</td>
                              </tr>
                              <tr>
                                <th>Last Name</th>
                                <td>{data.user_last_name}</td>
                              </tr>
                              <tr>
                                <th>Email</th>
                                <td>{data.user_email}</td>
                              </tr>
                            </tbody>
                          </table>
                          </div>
                      </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerProfile;
